import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config';

export const usePlatformSettings = () => {
  const [settings, setSettings] = useState({
    platform_name: 'ChamaLink',
    platform_logo_url: null,
    platform_logo_text: '💰'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/admin/settings`);
        setSettings(response.data);
      } catch (error) {
        console.error('Failed to load platform settings:', error);
        // Use defaults on error
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, loading };
};
